"use strict";Object.defineProperty(exports, "__esModule", {value: true});const disallowedRanges = [
  '\x00-\x08',
  '\x0B-\x1F',
  '\x7F',
  '\u202A-\u202D',
  '\u2066-\u2069',
].join('')
 const sanitizationRegExp = new RegExp(`[${disallowedRanges}]`, 'g'); exports.sanitizationRegExp = sanitizationRegExp

 const cleanupStr = (str) => str.replace(exports.sanitizationRegExp, ""); exports.cleanupStr = cleanupStr
 const sanitizeStr = (str) => exports.cleanupStr.call(void 0, str.trim()); exports.sanitizeStr = sanitizeStr
 const sanitizeFileName = (str) => exports.sanitizeStr.call(void 0, str)
  .replace(/[^A-Za-z0-9!$()-+=_., ]/g, '_'); exports.sanitizeFileName = sanitizeFileName

 const compareStr = (a, b) => {
  a = a ? String(a).toLowerCase() : ''
  b = b ? String(b).toLowerCase() : ''
  return a.localeCompare(b)
}; exports.compareStr = compareStr

 const isSubstring = (needle, haystack) =>
  haystack.toLowerCase().includes(needle.toLowerCase()); exports.isSubstring = isSubstring

// Runes that put no ink on the screen: whitespace, every control and format
// character (Cc/Cf covers the zero-width and bidi marks, the tag characters and
// the Arabic format signs), and the object-replacement character some clients
// substitute for an inline attachment.
//
// Verified against the backend's validate.IsBlank rune by rune across the whole
// of Unicode in the direction that matters: this never treats as blank anything
// the backend would accept, so it cannot silently eat a real message. The
// reverse gap is real and benign -- Go ships Unicode 15 tables, so a letter from
// a newer script (U+10D40 Garay, say) is unassigned to Go and blank to it while
// this treats it as content. The backend rejects it and the sender sees an
// error rather than a phantom message. Closes when Go's tables update.
const invisibleRunes = /[\s\p{Cc}\p{Cf}\uFFFC]/gu

/**
 * True when `str` renders as nothing at all — it is empty, or every rune in it
 * is invisible.
 *
 * Guard every send path with this, never with `!value` or `value !== ''`. A body
 * of one zero-width space is truthy, has length 1, and still arrives as an empty
 * bubble in the recipient's thread.
 *
 * That is why the composer's send control is guarded (TM-604). It renders
 * unconditionally, including over an untouched input — it replaced a thumbs-up
 * quick-send that was shown only while the input was empty, so before that change
 * an empty composer had no send target at all. A `blm.care` link is opened by
 * whoever holds it, which in practice means an email-security scanner that clicks
 * every control on the page. Assume a robot will click anything you add here in
 * its default state.
 *
 * The backend's validate.IsBlank enforces the same rule and is the authority;
 * this keeps a person from ever seeing the resulting error. The two rune lists
 * are kept in step by convention — see the note on invisibleRunes.
 */
 const isBlank = (str) =>
  !str || str.replace(invisibleRunes, '') === ''; exports.isBlank = isBlank
